import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import BrandSection from './components/BrandSection';
import MilestonesSection from './components/MilestonesSection';
import ReputationSection from './components/ReputationSection';
import ContactSection from './components/ContactSection';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Breadcrumb items={[{ label: '关于我们' }]} />
      <main>
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center py-12">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
              关于彩客网
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              专业彩票数据服务平台 · 值得信赖的选择
            </p>
          </div>
        </div>
        <BrandSection />
        <MilestonesSection />
        <ReputationSection />
        <ContactSection />

        <section className="py-12 bg-background-50">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
              常见问题
            </h2>
            <div className="flex flex-col gap-4">
              {[
                {
                  q: '彩客网的数据来源是什么？',
                  a: '彩客网所有开奖数据均来源于中国福利彩票发行管理中心和国家体育总局体育彩票管理中心的官方公布数据，我们通过多重校验确保数据准确无误。',
                },
                {
                  q: '如何注册彩客网账号？',
                  a: '您可以在彩客网首页点击"免费注册"按钮，输入手机号码获取验证码，设置密码后即可完成注册。注册即享专属福利和个性化服务。',
                },
                {
                  q: '彩客网的智能预测功能准确吗？',
                  a: '智能预测基于历史数据和AI算法，提供号码走势参考。但彩票本质上是随机概率游戏，预测结果仅供娱乐参考，不构成任何中奖承诺。',
                },
                {
                  q: '彩客网是否收费？',
                  a: '彩客网基础数据查询服务完全免费。部分高级分析功能可能需要会员权限，但我们提供充足的基础功能满足大多数用户的需求。',
                },
                {
                  q: '如何联系彩客网客服？',
                  a: '您可以通过以下方式联系我们：客服热线400-888-6666（7×24小时）、电子邮箱service@caikewang.com，或关注微信公众号"彩客网官方"。',
                },
              ].map((faq, idx) => (
                <details
                  key={idx}
                  className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
                >
                  <summary className="flex items-center justify-between px-5 py-4 text-sm font-medium text-foreground-900 cursor-pointer hover:bg-background-100 transition-colors list-none">
                    <span>{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于彩客网',
            description:
              '彩客网成立于2015年，是国内领先的彩票数据查询与智能分析平台，覆盖双色球、大乐透、福彩3D、排列三、七星彩等主流彩种。',
            url: 'https://www.caikewang.com/about',
            mainEntity: {
              '@type': 'Organization',
              name: '彩客网',
              url: 'https://www.caikewang.com',
              foundingDate: '2015',
              foundingLocation: '北京市',
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'customer service',
                telephone: '400-888-6666',
                email: 'service@caikewang.com',
              },
            },
            isPartOf: {
              '@type': 'WebSite',
              name: '彩客网',
              url: 'https://www.caikewang.com',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.caikewang.com',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '关于我们',
                item: 'https://www.caikewang.com/about',
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '彩客网的数据来源是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '彩客网所有开奖数据均来源于中国福利彩票发行管理中心和国家体育总局体育彩票管理中心的官方公布数据，我们通过多重校验确保数据准确无误。',
                },
              },
              {
                '@type': 'Question',
                name: '如何注册彩客网账号？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以在彩客网首页点击"免费注册"按钮，输入手机号码获取验证码，设置密码后即可完成注册。注册即享专属福利和个性化服务。',
                },
              },
              {
                '@type': 'Question',
                name: '彩客网的智能预测功能准确吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '智能预测基于历史数据和AI算法，提供号码走势参考。但彩票本质上是随机概率游戏，预测结果仅供娱乐参考，不构成任何中奖承诺。',
                },
              },
              {
                '@type': 'Question',
                name: '彩客网是否收费？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '彩客网基础数据查询服务完全免费。部分高级分析功能可能需要会员权限，但我们提供充足的基础功能满足大多数用户的需求。',
                },
              },
              {
                '@type': 'Question',
                name: '如何联系彩客网客服？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过以下方式联系我们：客服热线400-888-6666（7×24小时）、电子邮箱service@caikewang.com，或关注微信公众号"彩客网官方"。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}